import * as Yup from 'yup';

import { IGuestListItem } from 'modules/accommodations/features/partners/models';

// STEP 2: New Guest
export const NewGuestPhysicalPersonValidationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('Required'),
  lastName: Yup.string().trim().required('Required'),
  gender: Yup.string(),
  birthDate: Yup.string(),
  languageId: Yup.string().nullable(),
  email: Yup.string().trim().email('Invalid email').required('Required'),
  mobileNumber: Yup.string().trim().required('Required'),
  phone: Yup.string(),
  address: Yup.string(),
  postalCode: Yup.string(),
  city: Yup.string(),
  countryId: Yup.string().nullable(),
  remark: Yup.string(),
});

export const NewGuestCompanyValidationSchema = Yup.object().shape(
  {
    name: Yup.string().trim().required('Required'),
    languageId: Yup.string(),
    oib: Yup.string()
      .trim()
      .when('vat', {
        is: (vat: string) => !vat,
        then: Yup.string().required('Required'),
        otherwise: Yup.string(),
      }),
    vat: Yup.string()
      .trim()
      .when('oib', {
        is: (oib: number) => !oib,
        then: Yup.string().required('Required'),
        otherwise: Yup.string(),
      }),
    address: Yup.string(),
    postalCode: Yup.string().nullable(),
    city: Yup.string().nullable(),
    countryId: Yup.string().nullable(),
    email: Yup.string(),
    mobile: Yup.string(),
    phone: Yup.string(),
    remark: Yup.string(),
  },
  [['oib', 'vat']],
);
export interface INewGuestPhysicalPerson {
  firstName: string;
  lastName: string;
  gender: string;
  birthDay: string | null;
  languageId: number | null;
  email: string;
  mobileNumber: string;
  phoneNumber: string;
  address: string;
  postCode: string;
  place: string;
  countryId: number | null;
  note: string;
  newGuestPhysicalPerson: boolean;
}
export interface INewGuestCompany {
  firstName: string;
  languageId: number | null;
  oib: string;
  vat: string;
  address: string;
  postCode: string;
  place: string;
  countryId: number | null;
  email: string;
  mobileNumber: string;
  phoneNumber: string;
  note: string;
  newGuestCompany: boolean;
}
export interface IGuest {
  address: string;
  checked: boolean;
  country: string;
  email: string;
  id: string;
  language: string;
  name: string;
  oib: string;
  phoneNumber: string;
  place: string;
  postCode: string;
  vatNumber: string;
}

// STEP 2: Existing Guest
export const ExistingGuestValidationSchema = Yup.object().shape({
  term: Yup.string().trim().required('Required'),
});

export interface IExistingGuest {
  term: string;
  existingGuest: boolean;
}

export type TGuestSelectionTableState = {
  newGuestPhysicalPersonFormData: object;
  isModalVisible: boolean;
  tableData: IGuestListItem[];
};
